<template>
  <div class="wrappertabs">


    <search-group title="" @search="findData" @clear="clearValue" :span="24" :btnOffset="18" :btnSpan="6"
                  :multipleLines="false" :inline="true"
                  style="padding: 0"
    >
      <Row class="mb16" :gutter="16">
        <Col span="5">
          <Select v-model="searchData.projectFid" placeholder="项目名称">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="5">
          <DatePicker style="width:100%" v-model="searchData.createTime" split-panels type="daterange" format="yyyy-MM-dd"
                      placeholder="计入日期筛选"></DatePicker>
        </Col>
      </Row>
    </search-group >

    <table-list
      class="mt12"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    ></table-list>
    <gop-info :n="infoN" :data="itemData"></gop-info>
  </div>

</template>

<script type="text/ecmascript-6">
  // import SearchGroup from 'components/SearchGroup/index';
  import {formatDateTime} from "../../../../../utils/format";
  // import TableList from 'components/TableList/index';
  import {goplist} from "../../../../../api/gop";
  import {formatMoney} from "../../../../../utils/format";

  import GopInfo  from './GopInfo'


  export default {
    components: {
      // SearchGroup,
      // TableList,
      GopInfo
    },
    props: {
      projectList:{
        type:Array,
        default:()=>{return []}
      }
    },
    mounted() {
      this.findData()
    },
    computed: {
      searchDataComputed() {
        function f(data) {
          return data ? formatDateTime(data, false) : ''
        }
        return {
          projectFid: this.searchData.projectFid,
          startDate: f(this.searchData.createTime[0]),
          endDate:f(this.searchData.createTime[1]),
          dateType:1,
          gopType:1

        }
      }
    },
    data() {
      return {
        itemData:null,
        infoN:0,
        searchParams:null,
        data: [],
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: ' '
          },
          {
            title: '项目名称 ',
            align: 'center',
            key: 'projectName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '当日GOP ',
            align: 'center',
            key: 'gopValue',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatMoney(params.row['gopValue']))
            }
            // render:(h,params)=>{
            //   return h('a',{
            //     on:{
            //       click:()=>{
            //         let query = {
            //           fid: params.row['fid'],
            //         };
            //         this.$router.push({name:'personbookinfo',query:query})
            //       }
            //     }
            //   },params.row['fcode'])
            // }
          },
          {
            title: ' '
          },
          // {
          //   title: "合同数",
          //   align: 'center',
          //   key: 'contractCount',
          //   width: 120,
          // },
          // {
          //   title: ' '
          // },
          {
            title: '当月累计GOP',
            align: 'center',
            key: 'accumulateGop',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatMoney(params.row['accumulateGop']))
            }
            // render: (h, params) => {
            //   return h('span', {}, this.format(params.row['createTime']))
            // }
            // render:(h,params)=>{
            //   let maps={'1':'已超期','2':'待支付','3':'待签约','4':'已签约','5':'客户违约','6':'公司违约','7':'已取消' }
            //   return h('span',{},maps[params.row['reservationStatus']+''])
            // }
          },
          {
            title: ' '
          },
          {
            title: "所属月份",
            align: 'center',
            key: 'vestingMonth',
            width: 120,
          },
          {
            title: ' '
          },        {
            title: "计入日期",
            align: 'center',
            key: 'vestingDate',
            width: 120,
          },
          {
            title: ' '
          },
          // {
          //   title: '操作',
          //   align: 'center',
          //   key: 'action',
          //   width: 120,
          //   fixed: 'right',
          //   render: (h, params) => {
          //     return h('div', [
          //       h('a', {
          //         style: {
          //           // display: params.row.reservationStatus === 2 ?'inline-block' :'none',
          //           marginRight: '5px'
          //         },
          //         directives:[
          //           // {
          //           //   name:'p',
          //           //   value:{
          //           //     api:'storeFrontGrade/deleteStoreFrontGrade'
          //           //   }
          //           // }
          //         ],
          //         on:{
          //           click: ()=>{
          //             this.itemData=params.row
          //             this.infoN++

          //           }
          //         }
          //       }, '查看'),

          //     ])
          //   }
          // }

        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchData: {
          projectFid: '',
          createTime: ['', ''],

        },
      }
    },
    methods: {
      getData(){
        let params={
          ...this.searchParams,
          page:this.page,
          limit:this.limit
        }
        goplist(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          res.data.rows&& (this.data=res.data.rows)

        }).catch(error=>{
        })

      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()
      },
      findData() {
        this.searchParams=this.searchDataComputed
        this.page=1
        this.current=1
        this.getData()
      },
      clearValue() {
        this.searchData = {
          projectFid: '',
          createTime: ['', ''],
        }
      },
    },
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
</style>
